import http from '@/http-common'
import TabRequest from '../../components/RequestTab.vue'

export default {
    name: 'RequestSport',
    components: {TabRequest},
    props: {
        isCalled: {
            type: Boolean,
            default: false,
        },
        columns: {
            type: Array,
            default: () => [
                {key: 'stateRequestName', label: 'Состояние', sortable: true, tdClass: "tdClass"},
                {key: 'numYear', label: 'Номер заявки'},
                {key: 'dateRequest', label: 'Дата заявки'},
                {key: 'nameEvent', label: 'Наименование мероприятия', sortable: true},
                {key: 'organization', label: 'Организатор', sortable: true},
                {key: 'countPeople', label: 'Кол-во участников', sortable: true},
                {key: 'edit_field2', label: '', firstClass: 'width10', sortable: false}
            ],
        }
    },
    data() {
        return {
            items: [],
            isBusy: false,
            captionTable: 'Заявки на участие',
            captionSpr: {
                name: 'Заявки',
                nameR: 'Заявку'
            },
            selectedItem: {
                nameEvent: '',
                dateRequest: null,
                eventId: null,
                details: [],
                mainTrainer: null,
                mainDoctor: null
            },
            urls: {
                save: '/request/sport/save',
                delete: '/request/sport/delete',
            },
            filter: {other: null},
            modalEditOpened: false,
            filteredItems: [],
            planY: new Date().getFullYear(),
        }
    },
    created() {
        this.loadItems()
    },
    methods: {
        showEditDialog() {

        },
        onFiltered(filteredItems) {
            this.filteredItems = filteredItems
        },
        loadItems() {
            var vm = this
            var filter = ''
            if (this.planY)
                filter += '&year='+this.planY;
            http.get('/requestSport/listAll?' + filter)
                .then((response) => {
                    vm.items = response.data;
                    vm.isBusy = false
                    vm.showFilter = false
                    vm.onFiltered(vm.items)
                })
                .catch((error) => console.log(error.message))
        },
    }
}
